// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pe-8";
export var editMode = "_pe-3";
export var headerRow = "_pe-a";
export var headerTitle = "_pe-b";
export var product = "_pe-1";
export var productDetails = "_pe-5";
export var productDivider = "_pe-7";
export var productImage = "_pe-2";
export var productInfo = "_pe-4";
export var productTitle = "_pe-6";
export var strikethrough = "_pe-9";
export var upsellProductsCard = "_pe-0";